import React, { useState } from "react";
import { TextField, Grid, Paper, Button, Backdrop, CircularProgress, Alert, FormLabel, RadioGroup, FormControlLabel, Radio } from '@mui/material';
import { makeStyles } from '@mui/styles';
import axios from 'axios';
import { getAuthenticationToken } from '../utils/TokenHandler';
import MaterialNotifyComponent from "./MaterialNotifyComponent";
import { withRouter } from 'react-router-dom';
import { getUserProfile } from "../utils/userProfile";

function CustomerCheckSerialNumberForm(props) {
    const [messageNotify, setMessageNotify] = useState({ severity: "warning", message: "", open: false });
    const [open, setOpen] = useState(false);
    const [serialCode, setSerialCode] = useState('');
    const [serialNumberInfo, setSerialNumberInfo] = useState({
        customerUserName: null,
        storeCustomerUserName: null,
        serialComment: null,
        registerCustomerPersianDatetime: null,
        registerStoreCustomerPersianDateTime: null,
        showAlert: false
    });
    const [customerType, setCustomerType] = useState(0);

    const useStyles = makeStyles(theme => ({
        root: {
            "& .MuiFormLabel-root": {
                right: 0, // or black
                left: 'unset',
                color: '#ffffff'
            },
            "& .MuiInputLabel": {
                color: '#ffffff'
            },
            '& .MuiInput-root::after': {
                borderBottom: '2px solid #ffffff'
            },
            '& .MuiInputBase-input-MuiInput-input': {
                color: '#ffffff'
            },
            '& .Mui-focused': {
                color: '#ffffff !important'
            },
            '& .MuiInputBase-root': {
                color: '#ffffff !important'
            }
        }
    }));

    const classes = useStyles();
    const formElementStyle = {
        margin: "10px 0",
        backgroundColor: '#0072bc'
    };

    const formButtonElementStyle = {
        margin: "10px 0",
        backgroundColor: '#014171',
        fontSize: 'x-large',
        boxShadow: '0px 10px 20px 5px rgba(255, 255, 255, 0.2)'
    };

    const footerButtonStyle = {
        display: 'inline-block',
        padding: '0px 20px',
        width: '100%'
    };
    const footerButtonContainerStyle = {
        display: 'flex',
        justifyContent: 'space-evenly',
        position: 'fixed', left: '0',
        bottom: '0', width: '100%',
        zIndex: '1'
    };

    const paperStyle = {
        padding: 20,
        height: 'max-content',
        width: '70vw',
        margin: 'auto'
    };


    const handleSubmit = (e) => {
        e.preventDefault();
        setOpen(true);
        axios.get('/api/v1/Stuff/GetStuffSerialNumberInfo',
            {
                params: {
                    serialNumber: serialCode
                }
            }).then(response => {
                const data = response.data;

                let serialInfo = "";
                if (data.serialNumber == null) {
                    serialInfo = {
                        customerUserName: null,
                        storeCustomerUserName: null,
                        serialComment: 'شماره سریال در سیستم موجود نیست',
                        registerCustomerPersianDatetime: null,
                        registerStoreCustomerPersianDateTime: null
                    };
                } else {
                    // serialInfo += data.customerId == null ? '' : 'شماره موبایل مشتری : ' + data.customerUserName.replace('+98', '0') + '\n | ';
                    // serialInfo += data.storeCustomerId == null ? '' : 'شماره موبایل فروشنده : ' + data.storeCustomerUserName.replace('+98', '0') + '\n';
                    // serialInfo = serialInfo == '' ? 'شماره ای از سوی مشتری یا فروشنده برای این شماره سریال ثبت نشده است' : serialInfo;
                    serialInfo = {
                        customerUserName: (data.customerId == null ? null : data.customerUserName.replace('+98', '0')),
                        storeCustomerUserName: (data.storeCustomerId == null ? null : data.storeCustomerUserName.replace('+98', '0')),
                        serialComment: ((data.customerId == null && data.storeCustomerId == null) ? 'شماره ای از سوی مشتری یا فروشنده برای این شماره سریال ثبت نشده است' : null),
                        registerCustomerPersianDatetime: data.registerCustomerPersianDatetime,
                        registerStoreCustomerPersianDateTime: data.registerStoreCustomerPersianDateTime,
                        showAlert: true
                    };
                }
                setSerialNumberInfo(serialInfo);
            }).catch((e) => {
                setMessageNotify({
                    severity: "error",
                    message: "خطا در نمایش شماره سریال",
                    open: true
                });
            }).finally(() => {
                setOpen(false);
            });
    }
    const serialNumberInfoComment = serialNumberInfo.serialComment === null ? <span></span> : <h3>{serialNumberInfo.serialComment}</h3>;
    const serialNumberInfocustomerUserName = serialNumberInfo.customerUserName === null ? <span></span> :
        <div><h3>شماره موبایل مشتری : </h3><h4>{serialNumberInfo.customerUserName}</h4><h3>تاریخ ثبت : </h3><h4>{serialNumberInfo.registerCustomerPersianDatetime}</h4></div>;
    const serialNumberInfostoreCustomerUserName = serialNumberInfo.storeCustomerUserName === null ? <span></span> :
        <div><h3>شماره موبایل فروشنده : </h3><h4>{serialNumberInfo.storeCustomerUserName}</h4><h3>تاریخ ثبت : </h3><h4>{serialNumberInfo.registerStoreCustomerPersianDateTime}</h4></div>;
    console.log(serialNumberInfoComment);
    console.log(serialNumberInfocustomerUserName);
    console.log(serialNumberInfostoreCustomerUserName);
    return (
        <>
            <Alert variant="string" severity="info" icon={false}
                style={{
                    marginBottom: '10px',
                    color: '#ffffff',
                    fontSize: 'large',
                    textAlign: 'justify'
                }}>
                جهت چک کردن مشخصات خریدار و فروشنده محصول سریال روی محصول را وارد نمادید
            </Alert>
            <form onSubmit={handleSubmit}>
                <div style={paperStyle} >
                    <Grid container spacing={2}>
                        <Grid item xs={12} sm={12}>
                            <TextField
                                style={formElementStyle}
                                className={classes.root}
                                id="postalCode"
                                name="postalCode"
                                label="کد سریال محصول"
                                fullWidth
                                variant="standard"
                                value={serialCode}
                                onChange={e => setSerialCode(e.target.value)} />
                        </Grid>

                        <Grid item xs={12} sm={12}>
                            <Button
                                id="submit"
                                type='submit'
                                name="submit"
                                fullWidth
                                variant="contained"
                                color="secondary" >چک کردن سریال محصول</Button>
                        </Grid>
                        <Grid item xs={12} sm={12}>
                        </Grid>
                    </Grid>
                    <div style={footerButtonContainerStyle}>
                        <div style={footerButtonStyle}>
                            <Button
                                onClick={() => { props.history.push('/') }}
                                id="cancel"
                                name="cancel"
                                variant="contained"
                                color="success"
                                fullWidth
                                style={formButtonElementStyle}>انصراف</Button>
                        </div>
                    </div>
                </div>
            </form>
            <Alert variant="outlined" severity="warning" icon={false}
                style={{
                    margin: 'auto',
                    color: '#ffffff',
                    border: '1px solid #ffffff',
                    display: serialNumberInfo.showAlert ? '' : 'none'
                }}>
                {serialNumberInfoComment}
                {serialNumberInfocustomerUserName}
                {serialNumberInfostoreCustomerUserName}
            </Alert>
            <MaterialNotifyComponent onclose={() => { setMessageNotify({ ...messageNotify, open: false }) }} open={messageNotify.open} severity={messageNotify.severity} message={messageNotify.message} />
            <Backdrop
                sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                open={open}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </>
    );
}

export default withRouter(CustomerCheckSerialNumberForm);